/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useMemo, useRef, useState } from "react";
import { CssJobs } from "./css";
import { useTranslation } from "react-i18next";

// Artes
import EfeitoBranco from "../../assets/Images/efeitoBranco.png";
import EfeitoAzul from "../../assets/Images/efeitoAzul.png";
import SetaAzul from "../../assets/Images/setaAzul.png";
import RSimbolo from "../../assets/Images/R.png";
import SetaVermelha from "../../assets/Images/setaVermelha.png";
import whatsApp from "../../assets/Images/whatsapp.png";

const Jobs = ({ scrollToId }) => {
  	const { t, i18n } = useTranslation();

	// ✅ observa somente a SECTION
	const sectionRef = useRef(null);
	const [arrowRotation, setArrowRotation] = useState(0);
	
	const [hoveredArrow, setHoveredArrow] = useState(null);
	const [autoRotations, setAutoRotations] = useState({});

	const [inView, setInView] = useState(false);
	const [showItems, setShowItems] = useState(false);

	// Typewriter
	const linesToType = useMemo(
		() => [t("jobs.full1"), t("jobs.full2"), t("jobs.full3"), t("jobs.full4")],
		[i18n.language, t]
	);

	const [typedLines, setTypedLines] = useState(["", "", "", ""]);
	const [typeDone, setTypeDone] = useState(false);

	const items = useMemo(
		() => [
		{ title: t("jobs.items.0.title"), desc: t("jobs.items.0.desc") },
		{ title: t("jobs.items.1.title"), desc: t("jobs.items.1.desc") },
		{ title: t("jobs.items.2.title"), desc: t("jobs.items.2.desc") },
		{ title: t("jobs.items.3.title"), desc: t("jobs.items.3.desc") },
		{ title: t("jobs.items.4.title"), desc: t("jobs.items.4.desc") },
		{ title: t("jobs.items.5.title"), desc: t("jobs.items.5.desc") },
		{ title: t("jobs.items.6.title"), desc: t("jobs.items.6.desc") },
		{ title: t("jobs.items.7.title"), desc: t("jobs.items.7.desc") },
		{ title: t("jobs.items.8.title"), desc: t("jobs.items.8.desc") },
		{ title: t("jobs.items.9.title"), desc: t("jobs.items.9.desc") },
		],
		[i18n.language, t]
	);

	// ✅ Observer robusto (dispara antes e 1 vez)
	useEffect(() => {
		const el = sectionRef.current;
		if (!el) return;

		if (!("IntersectionObserver" in window)) {
		setInView(true);
		setShowItems(true);
		return;
		}

		const obs = new IntersectionObserver(
		([entry]) => {
			if (entry.isIntersecting) {
			setInView(true);
			setShowItems(true);
			obs.disconnect();
			}
		},
		{
			threshold: 0.12,
			rootMargin: "0px 0px -15% 0px", // dispara um pouco antes
		}
		);

		obs.observe(el);
		return () => obs.disconnect();
	}, []);

  	useEffect(() => {
		let ticking = false;

		const handleScroll = () => {
			if (!ticking) {
			window.requestAnimationFrame(() => {
				setArrowRotation(window.scrollY % 360);
				ticking = false;
			});

			ticking = true;
			}
		};

		window.addEventListener("scroll", handleScroll, { passive: true });

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	}, []);

	//Efeito aleatorio das setas
	useEffect(() => {
		if (!items.length) return;

		let nextTimeout;
		let removeTimeout;

		const scheduleRotation = () => {
			const randomIndex = Math.floor(Math.random() * items.length);

			setAutoRotations((prev) => ({
			...prev,
			[randomIndex]: (prev[randomIndex] || 0) + 1,
			}));

			const nextDelay = Math.floor(Math.random() * 2200) + 1200;
			nextTimeout = setTimeout(scheduleRotation, nextDelay);
		};

		nextTimeout = setTimeout(scheduleRotation, 1500);

		return () => {
			clearTimeout(nextTimeout);
			clearTimeout(removeTimeout);
		};
	}, [items.length]);

	// reset quando troca idioma
	useEffect(() => {
		setTypedLines(["", "", "", ""]);
		setTypeDone(false);
	}, [i18n.language]);

	// typewriter roda quando entrou em view
	useEffect(() => {
		if (!inView) return;

		let cancelled = false;

		const charDelay = 18;
		const linePause = 120;

		async function run() {
		const next = ["", "", "", ""];

		for (let li = 0; li < linesToType.length; li++) {
			const line = linesToType[li] || "";
			for (let c = 0; c < line.length; c++) {
			if (cancelled) return;
			next[li] += line[c];
			setTypedLines([...next]);
			// eslint-disable-next-line no-await-in-loop
			await new Promise((r) => setTimeout(r, charDelay));
			}
			// eslint-disable-next-line no-await-in-loop
			await new Promise((r) => setTimeout(r, linePause));
		}

		if (!cancelled) setTypeDone(true);
		}

		run();
		return () => {
		cancelled = true;
		};
	}, [inView, linesToType]);

	// CTA
	/* const handleTalk = (e) => {
		e.preventDefault();
		if (scrollToId) return scrollToId(e, "contact");
		const el = document.getElementById("contact");
		if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
	}; */

	const whatsappLink =
		i18n.language === "en"
			? "https://wa.me/5511980130098?text=Hello%2C%20I%20found%20ZEST%20through%20your%20website%20and%20would%20like%20to%20understand%20how%20you%20can%20help%20my%20brand%20grow."
			: "https://wa.me/5511980130098?text=Ol%C3%A1%2C%20vim%20pelo%20site%20da%20ZEST%20e%20quero%20entender%20como%20voc%C3%AAs%20podem%20ajudar%20minha%20marca%20a%20crescer."
	;

  return (
    <CssJobs className="jobsWrap">
      {/* ✅ classe is-in agora fica NO SECTION */}
      <section
        className={`jobs ${inView ? "is-in" : ""}`}
        id="jobs"
        ref={sectionRef}
      >
			{/* FX topo esquerdo */}
			<img className="jobsFx jobsFx--branco" src={EfeitoBranco} alt="" />
			<img className="jobsFx jobsFx--azul" src={EfeitoAzul} alt="" />

			{/* seta topo direito */}
			<img
				className="jobsArrowTop"
				src={SetaAzul}
				alt=""
				aria-hidden="true"
				style={{ transform: `translateY(0) rotate(${arrowRotation}deg)` }}
			/>

			<div className="jobs__inner">
				{/* LEFT */}
				<div className="jobs__left">
					<div className="jobs__typing" aria-label="Full statements">
						<div className="jobsLine">
							{typedLines[0]}
							{!typeDone && <span className="jobsCaret" />}
						</div>
						<div className="jobsLine">{typedLines[1]}</div>
						<div className="jobsLine">{typedLines[2]}</div>
						<div className="jobsLine">{typedLines[3]}</div>
					</div>
				
					<a
						href={whatsappLink}
						className="jobsBtn"
						target="_blank"
						rel="noreferrer"
					>
						<span>{t("jobs.cta")}  <img src={whatsApp} alt="WhatsApp" title="WhatsApp"/></span>   {/* {t("jobs.cta")} */}						
					</a>

					{/* R */}
					<div className="jobsR" aria-hidden="true">
						<img src={RSimbolo} alt="" />
					</div>
				</div>

				{/* RIGHT */}
				<div className="jobs__right">
					<div className={`jobsList ${showItems ? "is-show" : ""}`}>
						{
							items.map((it, idx) => (
								<div
									className="jobsItem"
									key={idx}
									style={{ transitionDelay: `${idx * 90}ms` }}
								>
									<div className="jobsItem__icon" aria-hidden="true">
										<img
											src={SetaVermelha}
											alt="Seta"
											style={{
											transform: `rotate(${(autoRotations[idx] || 0) * 360 + (hoveredArrow === idx ? 360 : 0)}deg)`,
											}}
										/>
									</div>

									<div
										className="jobsItem__text"
										onMouseEnter={() => setHoveredArrow(idx)}
										onMouseLeave={() => setHoveredArrow(null)}
									>
										<div className="jobsItem__title">{it.title}</div>
										<div className="jobsItem__desc">{it.desc}</div>
									</div>
								</div>
							))
						}
					</div>
				</div>
			</div>

      </section>
    </CssJobs>
  );
};

export default Jobs;